const solicitation = {
    state: {
        headimg: {},
        form: {},
        educations: [],
        exhibition: [],
        wing: [],
        birth: null,
        live: null,
        ajaxData: {}
    },
    mutations: {
        GET_DATA: (state, value) => {
            let data = JSON.parse(tools.cache.get('formData'));
            for (let i of data.educations) {
                if (i.enrolment_time) {
                    i.enrolment_time = new Date(i.enrolment_time);
                }
                if (i.graduation_time) {
                    i.graduation_time = new Date(i.graduation_time);
                }
            }
            for (let i of data.exhibition) {
                if (i.year) {
                    i.year = new Date(i.year);
                }
            }
            for (let i of data.wing) {
                if (i.year) {
                    i.year = new Date(i.year);
                }
            }
            if (data.form.birth_year) {
                data.form.birth_year = new Date(data.form.birth_year);
            }
            
            if (data) {
                state.headimg = data.headimg;
                state.form = data.form;
                state.educations = data.educations;
                state.exhibition = data.exhibition;
                state.wing = data.wing;
                state.birth = data.birth;
                state.live = data.live;
                state.ajaxData = data.ajaxData;
            }
        },
    },
    actions: {
        getData({ commit }, value) {
            commit('GET_DATA', value)
        }
    }
}

export default solicitation


// WEBPACK FOOTER //
// ./src/store/modules/solicitation.js